var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade-view-fast","mode":"out-in"}},[_c('router-view')],1),_c('Loader',{attrs:{"view":_vm.loadingStatus,"msg":_vm.msg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }